import styled from 'styled-components';

export const Container = styled.div`
  > img {
    display: block;
    margin: 10px auto;
  }

  > button {
    font-family: 'Montserrat';
    font-size: 1.6rem;
    color: #939393;
    background-color: #fff;
  }

  @media (max-width: 1260px) {
    > button {
      margin: 40px auto;
    }
  }

  @media (max-width: 1024px) {
    margin-top: 40px;
  }

  @media (max-width: 560px) {
    width: 100%;
    > button {
      width: 100%;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #e84e22;
  text-align: center;

  > span {
    display: block;
    font-family: 'Montserrat';
    font-size: 3rem;
    color: #fff;
  }
`;

export const AddCard = styled.span`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 1.4rem;
  color: var(--green24);
  margin-left: 10px;
`;

export const CreditCardBanners = styled.img`
  margin-right: -210px;
  margin-top: 20px;

  @media (max-width: 1260px) {
    margin-right: 0px;
  }
`;

export const Tooltip = styled.div`
  font-family: 'Montserrat';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #e84e22;
  text-align: center;
  max-width: 26.25rem;
`;

export const TooltipPaymentOption = styled(Tooltip)`
  max-width: 400px;
  text-align: center;
  margin: 20px auto 0px auto;
`;

export const GiftedRow = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 1200px) {
    justify-content: center;
  }
`;

export const IWasPresented = styled.div`
  display: flex;
  align-items: center;
  border: none;
  outline: 0;
  background-color: #fff;

  width: 100%;
  max-width: 500px;
  height: 120px;

  margin: 0 auto;
  padding: 20px;

  > img {
    width: 80px;
    margin-right: 40px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 100%;
    min-width: 260px;

    font-family: 'Montserrat';
    font-weight: 600;
    text-transform: uppercase;
    font-size: 1.25rem;
    color: var(--green24);

    > div {
      > div {
        margin: 6px 0px 0px 0px;
        width: 200px;
        height: 40px;
      }
      > button {
        font-family: 'Montserrat';
        font-weight: 600;
        font-size: 18px;
        color: #fff;
        width: 45px;
        height: 45px;
        background-color: #e84e22;
        border-radius: 50%;
        border: 0px;
        margin-left: 20px;
        margin-top: 6px;
        outline: 0;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 766px) {
    width: 100%;
    justify-content: center;
  }

  @media (max-width: 460px) {
    flex-direction: column;
    align-items: center;
    padding: 10px;

    > img {
      display: none;
    }
  }
`;

export const ModalPix = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
`;

export const ModalContentPix = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 500px;
  height: 100%;
  max-height: 600px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
  position: relative;

  > img {
    width: 100%;
    max-width: 300px;
    margin-bottom: 20px;
  }

  .button {
    position: absolute;
    top: 10px;
    right: 10px;
    border: 0;
    background-color: transparent;
    cursor: pointer;
  }

  .copy {
    margin: 20px 0;
    border: 1px solid #e84e22;
    background-color: transparent;
    cursor: pointer;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    color: #e84e22;
    width: 100%;
    height: 45px;
  }

  .coped {
    margin: 20px 0;
    border: 1px solid #6be822;
    background-color: transparent;
    cursor: pointer;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 18px;
    color: #6be822;
    width: 100%;
    height: 45px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    max-height: 120px;
    overflow-y: auto;
  }

  > div::-webkit-scrollbar {
    width: 10px;
  }

  > div::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  > div::-webkit-scrollbar-thumb {
    background: #888;
  }

  > div::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  @media (max-width: 460px) {
    max-width: 300px;
    max-height: 300px;
  }

  @media (max-width: 360px) {
    max-width: 300px;
    max-height: 700px;
  }

  @media (max-width: 320px) {
    max-width: 300px;
    max-height: 600px;
  }

  @media (max-width: 280px) {
    max-width: 275px;
    max-height: 600px;
  }
`;
